<template>
  <div class="linkFormSectionWrap">
    <other-card :remarks.sync="ruleForm.comment" />
  </div>
</template>

<script>
import otherCard from '../../otherCard.vue'

export default {
  name: 'GenericResourceOtherSection',
  components: { otherCard },
  props: {
    ruleForm: { type: Object, required: true },
  },
  methods: {
    validate() {
      return Promise.resolve()
    },
    captureSnapshot() {
      return { comment: this.ruleForm.comment }
    },
  },
}
</script>
